import './index.css'
import { getImageSrc } from '@disco/content-editor/editor-utils'
import * as React from 'react'
import type { ImageProps } from 'types/content-editor'
import CampaignImageIcon from './campaign-image-icon'

const ImageBlock = (
  props: ImageProps,
):
  | React.ReactElement<'a'>
  | React.ReactElement<'div'>
  | React.ReactElement<'img'> => {
  const { width, link } = props
  let isEditor = false

  if (props.campaignData && props.campaignData.isEditor) {
    isEditor = true
  }

  const image = getImageSrc(props)
  const child = image ? (
    <img
      className="content-editor__image-block"
      src={image}
      width={width} // width always has priority in mjml
      // height={height}
    />
  ) : (
    <div className="content-editor__image-placeholder">
      <div>
        <CampaignImageIcon />
        {isEditor && (
          <div className="content-editor__image-tip">
            To add your image, click the pencil icon
          </div>
        )}
      </div>
    </div>
  )
  return link ? (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {child}
    </a>
  ) : (
    child
  )
}

export default ImageBlock
